import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/PrintImports';
import { Orders } from "models/OrdersModel";
import { User } from 'models/UserModel';
import { Doctor } from 'models/DoctorModel';
import { Client } from 'models/ClientModel';
import { ItemInventory } from "models/ItemInventoryModel";
import { Class } from 'constants/codes';
import { HtmlDataFormat } from "components/common/HtmlFormat"

const OrdersPrint: React.FC = () => {
  const width = { desc:100 }
  const [formId, formName] = [Code.Form.Id.ORDERS, Code.Form.Name.ORDERS];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef } = usePrintContext();
  const [orderData, setOrderData] = useState<Orders>({});
  const [itemInventoryData, setItemInventoryData] = useState<ItemInventory[]>([]); 
  const [clientData, setClientData] = useState<Client | null>(null);
  const [doctorData, setDoctorData] = useState<Doctor | null>(null);
  const [userData, setUserData] = useState<User | null>(null);
  

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasPrint(Privilege);
  const printRef = useRef<HTMLDivElement>(null);
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    API.Data.GetByKeyId<Orders>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setOrderData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      callItemList(data.orders_id);
      setClientData(await API.Data.GetClient(data.client_id));
      setDoctorData(await API.Data.GetDoctor(data.doctor_id));
      setUserData(await API.Data.GetUser(data.user_id));
    }})
    setLoading(false);
  }, []); 

  const callItemList = async (ordersId: number | undefined) => {
     if (!ordersId) return;  
       const url = API.Build.FormApiEndpint(Code.Form.Name.ITEM, 200, Name.Item.Id, Code.Option.Sort.ASC, {
       fields: Utility.Join.Fields([
         Name.Item.All, 
         Name.Product.Name, 
         Name.Item.UTN,
         Name.Item.SKU,
         Name.Item.ItemStatusName,
         Name.Item.OrderStatusName,
         Name.Inventory.Data,
         Name.Specification.Id,
       ]),
       [Name.Common.FormId]: Code.Form.Id.ORDERS,
       [Name.Common.CommonId]: ordersId,
     });
     //console.log("Item List URL----------->:",url);
     await API.Data.List<ItemInventory>(url, setItemInventoryData, setError, setLoading);
   };

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={formName} Privilege={Privilege} clientData={clientData} fileName='order' printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <Control.Flex>
              <Control.Column size={[0,60,0,0]}>
                <Control.Box>
                  <Field.CompanyHead companyId={companyId} locationId={locationId} />
                </Control.Box>
                <Control.Box>
                  <Field.Value value={Utility.Get.FullName(clientData, Code.Form.Name.CLIENT).toUpperCase()} valueBold={true} />
                  <Field.Value value={Utility.Format.Phone(clientData?.client_phone)} />
                  <Field.Value value={clientData?.client_address || ''} />
                  <Field.Value value={`${clientData?.city_name || ''} ${clientData?.client_postal || ''}`} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.SubHead title={formName} />
                  <Control.Form.Barcode value={orderData.orders_number!} />       
                  <Field.Value title={Title.SNo} value={orderData.orders_number} />
                  <Field.Value title={Title.Date} value={Utility.Format.DateOnly(orderData.orders_date)} />
                  <Field.Value title={Title.Doctor} value={Utility.Get.FullName(doctorData,Code.Form.Name.DOCTOR)} />
                  <Field.Value title={Title.Dispenser} value={Utility.Get.FullName(userData,Code.Form.Name.USER)} />
                  <Field.Value title={Title.Client} value={`#${clientData?.client_number}`} />
                  <Field.Value title={Title.DOB} value={Utility.Format.DateOnly(clientData?.client_dob)} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>
            <Control.Form.Table>
              <Control.Form.Title>
                <Control.Grid.Items values={[
                  ["Product/Specifications", width.desc], 
                ]} />
              </Control.Form.Title>
              <Control.Form.List>
                {itemInventoryData?.map((item, index) => (
                  <Control.Form.Index key={index} index={index} >
                    <Control.Form.OrderPrint 
                      specification={item.specification_id}
                      data={HtmlDataFormat(item.specification_id, item.inventory_data)}
                      productName={item.product_name} 
                      utncode={item.item_utncode} 
                      skucode={item.item_skucode} 
                    />
                  </Control.Form.Index>
                ))}
              </Control.Form.List>
            </Control.Form.Table>
            <Field.PrintedOn />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default OrdersPrint;